import { Badge, BadgeProps } from "@vinomofo/components";

export const AwardBadge = ({ count, ...rest }: BadgeProps): JSX.Element => {
  return <Badge {...rest} count={count > 1 ? count : undefined} />;
};
